export enum EnumTipoContratoATR {
  Anual = 1,
  Eventual_Medido = 2,
  Temporada = 3,
  Regimen_Especial = 4,
  Obras = 5,
  Socorro = 6,
  Eventual_Tanto_Alzado = 7,
  Pruebas = 8,
  Duplicado = 9,
  Reserva = 10
}
